export default "__VITE_ASSET__BxELPKoC__"